import React from 'react'
import { FaFacebookF, FaLinkedinIn, FaWhatsapp, FaInstagram } from "react-icons/fa";
import { contactImg } from "../../assets/index";

const ContactLeft = () => {
  return (
    <div className="w-full lgl:w-[35%] h-full bg-gradient-to-r from-[#1e2024] to-[#23272b] p-4 lgl:p-8 rounded-lg shadow-shadowOne flex flex-col gap-8 justify-center">
      <img
        className="w-full h-64 object-cover rounded-lg mb-2"
        src={contactImg}
        alt="contactImg"
      />
      <div className="flex flex-col gap-4">
        <h3 className="text-3xl font-bold text-white">Sensei Sultan</h3>
        <p className="text-lg font-normal text-gray-400">
          KARATE GURU
        </p>
        <p className="text-base text-gray-400 tracking-wide">
        I am a dedicated and accomplished martial artist with a strong background in karate. Holding a 2nd Dan black belt in KIO,
        I possess exceptional skills in various weapons, including BO and Nunchaku. With a passion for teaching, 
        I have been sharing my expertise since 2014 and have successfully trained numerous students, instilling in them self-defense techniques, 
        self-confidence, and discipline. Notably, my outstanding performance has earned me three national gold medals and nine state gold medals. 
        My extensive experience and commitment to martial arts have also led to recognition as the Best Technical Fighter and a national referee. 
        Alongside my martial arts pursuits, I hold a Bachelor's degree in Computer Science. 
        With my expertise in BO and Nunchaku,
        I am well-equipped to contribute to the development of self-defense skills and empower students of all ages.
        </p>
        <p className="text-base text-gray-400 flex items-center gap-2">
          Phone: <span className="text-lightText">+91 8105709544</span>
        </p>
        <p className="text-base text-gray-400 flex items-center gap-2">
          Email: <span className="text-lightText">senseisultan.it@gmail.com</span>
        </p>
      </div>
      <div className="flex flex-col gap-4">
        <h2 className="text-base uppercase font-titleFont mb-4">Find More About Karate Guru</h2>
        <div className="flex gap-4">
          {/* <span className="bannerIcon">
            <FaFacebookF />
          </span>
          <span className="bannerIcon">
            <FaTwitter />
          </span>
          <span className="bannerIcon">
            <FaLinkedinIn />
          </span> */}
                  <a href="https://www.facebook.com/SenseiSultan" target="_blank" rel="noopener noreferrer">
                  <span class="bannerIcon">
                  <FaFacebookF/>
                  </span>
                  </a>
                  <a href="https://www.instagram.com/sultankarateguru" target="_blank" rel="noopener noreferrer">
                  <span className="bannerIcon">
                    <FaInstagram/>
                  </span>
                  </a>
                  <a href="https://wa.me/+918105709544" target="_blank" rel="noopener noreferrer">
                  <span className="bannerIcon">
                    <FaWhatsapp />
                  </span>
                  </a>
                  <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer">
                  <span className="bannerIcon">
                    <FaLinkedinIn />
                  </span>
                  </a>
                  {/* <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer">
                  <span className="bannerIcon">
                    <FaTwitter />
                  </span>
                  </a> */}
        </div>
      </div>
    </div>
  );
}

export default ContactLeft